type DefaultRouteSearch = 'pId' | 'sId'

export default <keys extends string = never>(search = location.search) => (
  Object.fromEntries(
    new URLSearchParams(search).entries(),
  ) as Partial<Record<keys | DefaultRouteSearch, string>>
);
